import { useCallback, useMemo } from "react"
import { useDialog } from "lib/@hooks/useDialog"
import { createMacro } from "authoring/routes/macro/controller/create-macro"
import { buildMacroCategoryList } from "authoring/routes/macro/lib/macro-category-utils"
import { normalizeMacroName } from "authoring/routes/macro/lib/macro-utils"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { CreateMacroDialog } from "authoring/routes/macro/components/create-macro-dialog"

export function useCreateMacroDialog({ macros = [], categories, onCreated } = {}) {
    const categoryOptions = useMemo(() => categories ?? buildMacroCategoryList(macros), [categories, macros])
    const openCreateDialog = useDialog(<CreateMacroDialog categories={categoryOptions} />, { maxWidth: "md" })

    const openCreateMacro = useCallback(async () => {
        try {
            const draft = await openCreateDialog()
            if (!draft) return null

            const normalizedName = normalizeMacroName(draft?.name)
            const created = await createMacro({ input: { ...draft, name: normalizedName } })
            if (created) {
                successSnackbar("Macro created")
                onCreated?.(created)
                return created
            }
            errorSnackbar("Failed to create macro")
        } catch (error) {
            console.error(error)
            errorSnackbar(error?.message || "Failed to create macro")
        }
        return null
    }, [onCreated, openCreateDialog])

    return { openCreateMacro }
}
